// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ReactElement, type ComponentProps } from 'react';
import { MAP_FROM_SERVER_COLOR } from '@atlassian/jira-issue-epic-color/src/common/constants.tsx';
import type { Color } from '@atlassian/jira-issue-epic-color-types/src/types.tsx';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import type { EpicOption, Group } from '../../common/types/index.tsx';
import messages from './messages.tsx';
import { ColorPatch } from './styled.tsx';
import type { RestAPIResponse, RestEpic } from './types.tsx';

export const getOptionColorElem = (
	color: Color,
): ReactElement<ComponentProps<typeof ColorPatch>> => <ColorPatch color={color} />;

export const toSuggestionsItem = (epic: RestEpic): EpicOption => {
	const color = MAP_FROM_SERVER_COLOR[epic.issueColor.key];

	return {
		color,
		label: epic.summary,
		value: epic.key,
		id: epic.id.toString(),
		description: epic.key,
		elemBefore: getOptionColorElem(color),
		filterValues: [epic.summary, epic.key],
		isDone: epic.done,
	};
};

export const transformSuggestions = (
	response: RestAPIResponse,
	formatMessage: FormatMessage,
): Group => {
	const epicLists = response.values || [];
	const epicLink = [
		{
			label: formatMessage(messages.allEpics),
			options: epicLists.map(toSuggestionsItem),
		},
	];
	return epicLink;
};

export const mapEpicLinkOptionToData = ({ value }: EpicOption): string => value;
